import blog_img_7 from "../../assets/images/blog/blog-7.jpg"
import blog_img_8 from "../../assets/images/blog/blog-8.jpg"
import blog_img_9 from "../../assets/images/blog/blog-9.jpg"
import blog_img_10 from "../../assets/images/blog/blog-10.jpg"
import blog_img_11 from "../../assets/images/blog/blog-11.jpg"
import blog_img_12 from "../../assets/images/blog/blog-12.jpg"
import blog_img_13 from "../../assets/images/blog/blog-13.jpg"
import blog_img_14 from "../../assets/images/blog/blog-14.jpg"
import blog_img_15 from "../../assets/images/blog/blog-15.jpg"

export const blogData = [
    {
        id: 1,
        title: "Navigating the Impact of Blockchain Technology in the Logistics Sector.",
        thumb: blog_img_7,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 2,
        title: "Ensuring Data Security Amid Office Transitions The Emerging Trend of 2024.",
        thumb: blog_img_8,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 3,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_9,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 4,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_10,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 5,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_11,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 6,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_12,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 7,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_13,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 8,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_14,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },
    {
        id: 9,
        title: "Securing the Future: How AI Redefines Customer Workload Protection.",
        thumb: blog_img_15,
        date: "November 6, 2024",
        author: "Admin",
        link: "/blog-details",
        author_link:"/author"
    },

]